import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "position";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const positionCreate = "Master/Position/create/";
export const positionList = "Master/Position/list/";
export const positionDetail = "Master/Position/detail/";
export const positionUpdate = "Master/Position/update/";
export const positionInactive = "Master/Position/inactive/";
export const positionActive = "Master/Position/active/";
export const positionEselon = "Master/Position/eselon/";
export const positionWorkUnit = "Master/Position/workUnit/";
export const positionRank = "Master/Position/rank/";
export const positionPeriodList = "Master/Position/periodList/";
export const positionDraft = "Master/Position/draft/";
export const positionSubmitDraft = "Master/Position/submitDraft/";
export const positionDetailDraft = "Master/Position/detailDraft/";
export const positionDeleteDraft = "Master/Position/deleteDraft/";
export const positionUpdateDraft = "Master/Position/updateDraft/";
export const positionDelete = "Master/Position/delete/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
